import { render, staticRenderFns } from "./MatchEPrescribe.vue?vue&type=template&id=791fec70"
import script from "./MatchEPrescribe.vue?vue&type=script&lang=js"
export * from "./MatchEPrescribe.vue?vue&type=script&lang=js"
import style0 from "./MatchEPrescribe.vue?vue&type=style&index=0&id=791fec70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports